import api from './axios';

export const listarAtuais = (idHospital) => api.get(`/hospitais/${idHospital}/avaliacoes`);

// Todos os hospitais numa chamada só (Dashboard/lista de Hospitais) — evita 1 chamada por
// hospital.
export const listarAtuaisTodosHospitais = () => api.get('/hospitais/avaliacoes-atuais');

export const listarHistorico = (idHospital, idRequisito) =>
  api.get(`/hospitais/${idHospital}/avaliacoes/${idRequisito}/historico`);

export const registrar = (idHospital, data) => api.post(`/hospitais/${idHospital}/avaliacoes`, data);
